import { useEffect, useState } from "react";
import Services from "../../services/services";
import { toast } from "react-toastify";
import QR_USDT from "../../assets/imgs/USDT_TRC20.JPG";
import { getVietQRURL } from "../../ultils";


const DepositInfoPopup = ({ initDeposit, handleClose }) => {
    const [method, setMethod] = useState(null);
    const [deposit, setDeposit] = useState({ ...initDeposit });
    const fetchDepositMethods = async () => {
        const res = await Services.Deposit.getDepositMethods();
        const data = await res.json();
        if (res.status === 200 && data.success === true) {
            const m = data.data.filter(m => m.callback === deposit.method_callback)[0];
            setMethod(m);
        }
        else {
            toast.error(`${res.status}: ${data.error ?? ""}`)
        }
    };

    // Fetching data
    useEffect(() => {
        fetchDepositMethods();
    }, []);

    const handleUpdateDepositInfor = async (confirm = false) => {
        if (confirm) {
            const res = await Services.Deposit.updateTransId(deposit.id, deposit.trans_id, deposit.sender_name);
            const data = await res.json();
            if (res.ok && data.success) {
                toast.success("Transaction ID updated successfully!");
                setDeposit(data.data);
            } else {
                toast.error(`code(${res.status}): ${data.error ?? ""}`);
            }
        } else {
            toast(
                ({ closeToast }) => (
                    <div className="w-96">
                        <div className="mb-2 text-red-500">
                            <span>Please make sure you enter the correct transaction information. If this value is not the same as the real transaction code, the deposit request will not be approved.</span>
                            <span></span>
                        </div>
                        <div className="flex gap-2 justify-end">
                            <button className="px-3 py-1 bg-green-500 hover:bg-green-700 text-white rounded"
                                onClick={async () => { handleUpdateDepositInfor(true); closeToast(); }}
                            >
                                Confirm
                            </button>
                            <button
                                className="px-3 py-1 bg-gray-500 hover:bg-gray-700  rounded"
                                onClick={closeToast}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                ),
                { autoClose: false }
            );
        }
    };
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
            <div className="max-w-xl mx-auto mt-5 bg-white p-8 rounded-lg shadow">
                <h2 className="text-2xl font-bold text-center">Pay via {method?.name}</h2>
                <div className="mt-6 flex gap-3">
                    <span className="mb-1 font-bold">
                        {method?.callback === "mb_bank" ? "Account number:" : "Address:"}
                    </span>
                    <span className="mb-1 font-medium">{method?.address}</span>
                </div>
                <div className="mt-3 flex gap-3">
                    <span className="mb-1 font-bold">Recipient name:</span>
                    <span className="mb-1 font-medium">{method?.recipient}</span>
                </div>
                <div className="mt-3 flex gap-3">
                    <span className="mb-1 font-bold">Transfer Amount:</span>
                    <span className="mb-1 font-medium">
                        {deposit.trans_amount.toLocaleString()} {deposit?.trans_currency}
                    </span>
                </div>
                <div className="mt-3 flex gap-3">
                    <span className="mb-1 font-semibold text-gray-500 italic">You will receive <b>${deposit?.received_amount.toLocaleString()}</b> to your balance {deposit.method_callback === "paypal" && `(cause of fees)`}</span>
                </div>
                {method?.callback === "mb_bank" ?
                    <>
                        <div className="mt-3 flex gap-3">
                            <span className="mb-1 font-bold">Transfer Content</span>
                            <span className="mb-1 font-medium">{deposit.trans_id}</span>
                        </div>
                        <label className="italic mt-3 break-words text-red-500">
                            *Please include the above code "<strong>{deposit.trans_id}</strong>"
                            in your payment message content for identification and confirmation.<br />
                        </label>
                        <div className="mt-3 flex justify-center">
                            <img
                                src={`${getVietQRURL(method?.address, deposit.trans_amount, deposit.trans_id, method?.recipient)}`}
                                // src={`https://img.vietqr.io/image/970422-${method?.address}-compact.png?amount=${Math.round(deposit.trans_amount)}&addInfo=${encodeURIComponent(deposit.trans_id)}&accountName=NGUYEN%20ANH%20KIET`}
                                alt="QR code"
                                className="max-w-xs w-full rounded"
                            />
                        </div>
                    </>
                    : method?.callback === "crypto_usdt" ?
                        <>
                            <div className="mt-3 flex justify-center">
                                <img
                                    src={QR_USDT}
                                    alt="QR code"
                                    className="max-w-xs w-full rounded"
                                />
                            </div>
                            <label className="italic mt-3 break-words text-red-500">
                                *After transferred the money to the account above, please obtain the <strong>platform's transaction id</strong> and
                                update it here for identification and confirmation.<br />
                            </label>
                            <div className="mt-3 flex gap-3 items-center">
                                <span className="font-bold">Transation ID</span>
                                <input type="text" className="border-2 rounded-md px-2 py-1 bg-gray-100"
                                    placeholder="Transaction ID..."
                                    value={deposit.trans_id}
                                    onChange={(e) => setDeposit({ ...deposit, trans_id: e.target.value })}
                                />
                                <button onClick={() => handleUpdateDepositInfor()} className="bg-green-500 px-2 py-1 text-white font-semibold hover:bg-green-700 rounded-md">
                                    Update
                                </button>
                            </div>
                        </>
                        : method?.callback === "paypal" ?
                            <>
                                <label className="italic mt-3 break-words text-red-500">
                                    *After transferred the money to the account above, please update the name of the Paypal account you used here for identification and confirmation.<br />
                                </label>
                                <div className="mt-3 flex gap-3 items-center">
                                    <span className="font-bold">Your Paypal name</span>
                                    <input type="text" className="border-2 rounded-md px-2 py-1 bg-gray-100"
                                        placeholder="Your Paypal name..."
                                        value={deposit.sender_name}
                                        onChange={(e) => setDeposit({ ...deposit, sender_name: e.target.value })}
                                    />
                                    <button onClick={() => handleUpdateDepositInfor()} className="bg-green-500 px-2 py-1 text-white font-semibold hover:bg-green-700 rounded-md">
                                        Update
                                    </button>
                                </div>
                            </>
                            : <></>
                }
                <label className="italic mt-3 break-words">
                    Deposit request will be verified in few minutes.
                </label>
                <div className="mt-4 flex gap-5 justify-center">
                    <button className="bg-gray-500 hover:bg-gray-700 w-20 h-9 text-white  rounded" onClick={() => handleClose()}>
                        Close
                    </button>
                </div>
            </div>
        </div >
    )
}
export default DepositInfoPopup;